import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React, { useState } from 'react';
import { View, TouchableOpacity } from 'react-native';
import { ButtonGroup } from '../../ButtonGroup/rn';
import { RichText } from '../../RichText/rn';
import { SimpleRichText } from '../../RichText/rn/SimpleRichText';
import ArrowDownSvg from '../../../assets/images/rn/ArrayDown';
import { CustomStyleSheet } from '../../../utils/rn/tools';
import { useTracking } from '../../../hooks/rn/useTracking';
export var MsgType;
(function (MsgType) {
  MsgType[MsgType["default"] = 0] = "default";
  MsgType[MsgType["changeOrder"] = 1] = "changeOrder";
})(MsgType || (MsgType = {}));
export var Message = function Message(props) {
  var _buttonGroup$buttons, _buttonGroup$buttons2;
  var _id = props._id,
    className = props.className,
    _props$styles = props.styles,
    styles = _props$styles === void 0 ? {
      containerStyle: {},
      textStyle: {}
    } : _props$styles,
    content = props.content,
    options = props.options,
    buttonGroup = props.buttonGroup,
    shouldHandleDateVariable = props.shouldHandleDateVariable,
    jumpNodeMap = props.jumpNodeMap,
    jumpOrderShortCutMap = props.jumpOrderShortCutMap,
    disableSpecialLink = props.disableSpecialLink,
    linkTrackingData = props.linkTrackingData,
    msgType = props.msgType,
    onImageError = props.onImageError,
    onImageLoad = props.onImageLoad,
    onCollapseClick = props.onCollapseClick,
    previewMockData = props.previewMockData,
    articleContentTrackingData = props.articleContentTrackingData,
    useSimpleRichText = props.useSimpleRichText,
    defaultRichTextWidth = props.defaultRichTextWidth,
    shouldSetContainerWidth = props.shouldSetContainerWidth,
    richTextSize = props.richTextSize,
    onWebViewSizeChange = props.onWebViewSizeChange,
    debounceSizeChange = props.debounceSizeChange,
    isUIOptimisationRecommender = props.isUIOptimisationRecommender,
    isUIOptimisationButton = props.isUIOptimisationButton,
    isUIOptimisationTable = props.isUIOptimisationTable,
    isUIOptimisationImgGifRichText = props.isUIOptimisationImgGifRichText,
    haveMinRichTextWidth = props.haveMinRichTextWidth,
    handleDisabledScroll = props.handleDisabledScroll,
    _props$richTextTouchE = props.richTextTouchEnd,
    richTextTouchEnd = _props$richTextTouchE === void 0 ? function () {} : _props$richTextTouchE;
  var _useState = useState(props.collapse),
    _useState2 = _slicedToArray(_useState, 2),
    collapse = _useState2[0],
    setCollapse = _useState2[1];
  var showButtonGroup = buttonGroup === null || buttonGroup === void 0 ? void 0 : (_buttonGroup$buttons = buttonGroup.buttons) === null || _buttonGroup$buttons === void 0 ? void 0 : _buttonGroup$buttons.filter(function (btn) {
    return !btn.hidden;
  }).length;
  var hasButtonGroup = !!buttonGroup && showButtonGroup;
  var isVerticalButtonGroup = hasButtonGroup && (buttonGroup === null || buttonGroup === void 0 ? void 0 : buttonGroup.layout) === 'vertical' && (buttonGroup === null || buttonGroup === void 0 ? void 0 : (_buttonGroup$buttons2 = buttonGroup.buttons) === null || _buttonGroup$buttons2 === void 0 ? void 0 : _buttonGroup$buttons2.some(function (button) {
    return ['primary', 'primary-outlined', 'secondary-outlined'].includes(button.type || 'default');
  }));
  var _useTracking = useTracking(props),
    trackingImpressionProps = _useTracking.trackingImpressionProps;
  var _useTracking2 = useTracking({
      trackingData: props.collapseTrackingData
    }),
    tracker = _useTracking2.tracker,
    trackingClick = _useTracking2.trackingClick,
    collapseTrackingImpressionProps = _useTracking2.trackingImpressionProps;
  return /*#__PURE__*/React.createElement(View, _extends({
    style: [Styles.message, styles === null || styles === void 0 ? void 0 : styles.containerStyle]
  }, trackingImpressionProps), useSimpleRichText ? /*#__PURE__*/React.createElement(SimpleRichText, {
    baseStyles: _objectSpread(_objectSpread(_objectSpread({}, Styles['message-content']), isVerticalButtonGroup && Styles.contentWithVerticalButtonStyle), styles === null || styles === void 0 ? void 0 : styles.textStyle),
    content: content,
    options: options,
    shouldHandleDateVariable: shouldHandleDateVariable,
    jumpNodeMap: jumpNodeMap,
    jumpOrderShortCutMap: jumpOrderShortCutMap,
    previewMockData: previewMockData,
    disableSpecialLink: disableSpecialLink,
    linkTrackingData: linkTrackingData,
    msgType: msgType,
    onImageError: onImageError,
    onImageLoad: onImageLoad,
    isUIOptimisationRecommender: isUIOptimisationRecommender
  }) : /*#__PURE__*/React.createElement(RichText, {
    className: "message-content ".concat(className),
    content: content,
    options: options,
    shouldHandleDateVariable: shouldHandleDateVariable,
    jumpNodeMap: jumpNodeMap,
    jumpOrderShortCutMap: jumpOrderShortCutMap,
    articleContentTrackingData: articleContentTrackingData,
    previewMockData: previewMockData,
    disableSpecialLink: disableSpecialLink,
    linkTrackingData: linkTrackingData,
    msgType: msgType,
    onImageError: onImageError,
    onImageLoad: onImageLoad,
    defaultWidth: defaultRichTextWidth,
    shouldSetContainerWidth: shouldSetContainerWidth,
    showLoading: false,
    richTextSize: richTextSize,
    onWebViewSizeChange: onWebViewSizeChange,
    debounceSizeChange: debounceSizeChange,
    isUIOptimisationButton: isUIOptimisationButton,
    isUIOptimisationTableModal: isUIOptimisationTable,
    isUIOptimisationImgGifRichText: isUIOptimisationImgGifRichText,
    haveMinRichTextWidth: haveMinRichTextWidth,
    handleDisabledScroll: handleDisabledScroll,
    richTextTouchEnd: richTextTouchEnd
  }), collapse ? /*#__PURE__*/React.createElement(View, collapseTrackingImpressionProps, /*#__PURE__*/React.createElement(TouchableOpacity, {
    onPress: function onPress() {
      trackingClick && tracker.click(trackingClick);
      onCollapseClick === null || onCollapseClick === void 0 ? void 0 : onCollapseClick();
      setCollapse(false);
    }
  }, /*#__PURE__*/React.createElement(ArrowDownSvg, {
    style: Styles['message-collapse-button']
  }))) : showButtonGroup ? /*#__PURE__*/React.createElement(ButtonGroup, _extends({
    _id: _id,
    styles: _objectSpread(_objectSpread({}, Styles['message-buttons']), isVerticalButtonGroup && Styles.verticalButtonGroupStyle)
  }, buttonGroup)) : null);
};
var Styles = CustomStyleSheet({
  message: {
    maxWidth: '100%'
  },
  'message-content': {
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 6,
    paddingBottom: 6
  },
  contentWithVerticalButtonStyle: {
    paddingHorizontal: 10,
    paddingTop: 6,
    paddingBottom: 4
  },
  'message-buttons': {
    minWidth: 244
  },
  'message-collapse-button': {
    width: '100%',
    display: 'flex',
    justifyContent: 'center'
  },
  verticalButtonGroupStyle: {
    paddingBottom: 6
  }
});